// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"f97b0c8a","486":"d0dd2de5","522":"44f43ee2","558":"cb2cd809","617":"48b0c777","675":"7863f2a1","782":"82dafedd","831":"850b0445","924":"e131cd73","994":"8965bf2e"}[chunkId] + ".chunk.js";
};